import type { Messages } from "@/i18n/locales/en";
import { legalMessagesUk } from "@/i18n/locales/legalUkData";
import { pagesMessagesUk } from "@/i18n/locales/pagesUkData";

export const ukMessages = {
  meta: {
    description:
      "WasOK — скануйте продукти, зберігайте оцінки та нотатки, пам’ятайте, що варто було купувати.",
    title: "WasOK — Пам’ятайте, що варто було купувати",
  },
  header: {
    navFeatures: "Функції",
    navHowItWorks: "Як це працює",
    navPrivacy: "Конфіденційність",
    navUseCases: "Випадки використання",
    download: "Завантажити",
    openMenu: "Відкрити меню",
    closeMenu: "Закрити меню",
    languageAria: "Мова",
  },
  hero: {
    badge: "📱 Тепер доступно на Android",
    title: "Пам’ятайте, що варто було купувати.",
    subtitle:
      "Скануйте продукти, зберігайте оцінки та нотатки — і миттєво згадуйте, чи був продукт справді хорошим.",
    googlePlay: "Завантажити з Google Play",
    watchDemo: "Дивитися демо",
    privacyLine: "Усі дані залишаються на вашому пристрої.",
    phoneTitle: "WasOK",
    phoneSubtitle: "Скануйте, щоб пам’ятати",
    snackCard: "Смачно!",
    coffeeCard: "Занадто гірка",
    scrollHint: "Прокрутіть, щоб дізнатися більше",
  },
  problems: {
    heading: "Знайомо?",
    subheading:
      "Усі ми це знаємо — стоїте перед полицею й намагаєтеся згадати, чи сподобалося минулого разу.",
    notedAgo: "✓ Ви записали це 3 місяці тому",
    items: [
      {
        question: "Який шоколад мені справді сподобався?",
        note: "Ідеальна солодкість",
      },
      {
        question: "Чому я перестав купувати цей шампунь?",
        note: "Сушив волосся",
      },
      {
        question: "Ця кава була хорошою чи розчарувала?",
        note: "Занадто гірка",
      },
    ],
  },
  howItWorks: {
    heading: "Як це працює",
    subheading:
      "Чотири прості кроки, щоб більше ніколи не забувати свої думки про продукти.",
    stepPrefix: "Крок",
    steps: [
      {
        title: "Відскануйте будь-який штрихкод продукту",
        description:
          "Швидке й просте сканування камерою. Працює з будь-яким штрихкодом.",
      },
      {
        title: "Зберігайте оцінки, коментарі та фото",
        description:
          "Оцінюйте продукти, додавайте нотатки, прикріплюйте фото та записуйте ціни й місця.",
      },
      {
        title: "Миттєво згадуйте свій досвід",
        description:
          "Пізніше відскануйте той самий продукт і побачите попередню оцінку та нотатки.",
      },
      {
        title: "Створюйте розумні списки покупок",
        description:
          "Створюйте списки покупок із продуктів, яким уже довіряєте й які любите.",
      },
    ],
  },
  privacy: {
    heading: "Ваша історія покупок залишається вашою.",
    body: "WasOK допомагає пам’ятати продукти, які ви пробували, зберігаючи оцінки, нотатки, фотографії та списки покупок локально на вашому пристрої.",
    trustBanner:
      "💚 Побудовано навколо вашої історії покупок — а не навколо збору ваших даних.",
    bullets: [
      "Обліковий запис не потрібен",
      "Хмарна синхронізація не потрібна",
      "Локальне сховище насамперед",
      "Резервні копії під вашим контролем",
      "Необов’язковий пошук за штрихкодом для інформації про продукти.",
      "Підтримується рекламою через Google AdMob",
    ],
  },
  features: {
    heading: "Усе, що вам потрібно",
    subheading:
      "Потужні функції, створені, щоб зробити відстеження продуктів простим і приватним.",
    items: [
      {
        title: "Сканер штрихкодів",
        description: "Швидке й точне сканування штрихкодів будь-якого продукту.",
      },
      {
        title: "Оцінки продуктів",
        description: "Оцінюйте продукти від 1 до 5 зірок, щоб пам’ятати якість.",
      },
      {
        title: "Фотографії продуктів",
        description: "Додавайте фото, щоб пам’ятати упаковку або деталі.",
      },
      {
        title: "Категорії",
        description: "Організовуйте продукти у власні категорії.",
      },
      {
        title: "Відстеження магазинів",
        description: "Пам’ятайте, де ви купили кожен продукт.",
      },
      {
        title: "Запис цін",
        description: "Відстежуйте ціни, щоб знаходити найкращі пропозиції.",
      },
      {
        title: "Списки покупок",
        description: "Створюйте списки з улюблених продуктів.",
      },
      {
        title: "Офлайн-доступ",
        description: "Працює ідеально без інтернет-з’єднання.",
      },
      {
        title: "Локальне сховище",
        description: "Усі ваші дані надійно зберігаються на пристрої.",
      },
    ],
  },
  useCases: {
    heading: "Ідеально для кожної полиці",
    subheading:
      "Чи купуєте ви їжу, косметику чи товари для дому — WasOK допомагає пам’ятати.",
    cards: [
      {
        emoji: "🍫",
        title: "Снеки та солодощі",
        description: "Пам’ятайте, які цукерки справді були смачними.",
      },
      {
        emoji: "☕",
        title: "Кава та напої",
        description: "Відстежуйте каву, яку варто купувати знову.",
      },
      {
        emoji: "💄",
        title: "Косметика та догляд",
        description: "Ведіть нотатки про реакції шкіри.",
      },
      {
        emoji: "🧹",
        title: "Товари для дому",
        description: "Уникайте повторної купівлі продуктів, які розчарували.",
      },
    ],
  },
  screenshots: {
    heading: "Красиво та інтуїтивно",
    subheading:
      "Продуманий інтерфейс, який робить відстеження продуктів приємним.",
    items: [
      { title: "Сканер" },
      { title: "Деталі продукту" },
      { title: "Введення оцінки" },
      { title: "Пошук і історія" },
      { title: "Список покупок" },
    ],
  },
  cta: {
    heading: "Пам’ять про покупки для реального життя.",
    body: "Припиніть забувати, які продукти варто було купувати. Почніть купувати розумніше вже сьогодні.",
    googlePlay: "Завантажити з Google Play",
    scanQr: "Відскануйте, щоб завантажити",
    tagline: "Приватно · Офлайн насамперед · Просто",
  },
  footer: {
    tagline: "Пам’ятайте, що варто було купувати.",
    linksHeading: "Посилання",
    privacyPolicy: "Політика конфіденційності",
    terms: "Умови використання",
    contact: "Контакт",
    linkFaq: "FAQ",
    linkLicenses: "Ліцензії відкритого коду",
    linkAdvertising: "Реклама та монетизація",
    downloadHeading: "Завантажити",
    googlePlay: "Google Play",
    copyright:
      "© 2026 WasOK. Усі права захищено. Зроблено з 💚 для розумніших покупок.",
  },
  legal: legalMessagesUk,
  faq: pagesMessagesUk.faq,
  support: pagesMessagesUk.support,
  advertising: pagesMessagesUk.advertising,
} satisfies Messages;
